import { KMotionUrl } from '../../constants/urls.constants';

function KMotionRedirect() {
  window.location.href = KMotionUrl; 
  return null;
};

export default KMotionRedirect;